import React, { useContext } from 'react'
import messages from '../../messages'
import { useIntl, useUser } from '@platform/cj-platform-navigation'
import { CommissionAdminValues, AuthValues } from '../../types'
import CommissionAdminContext from '../../context/CommissionAdminContext'
import AuthContext from '../../context/AuthContext'
import Unauthorized from '../../components/403'
import { PageContent } from '@cjdev-internal/visual-stack-x/components/PageContent'
import { Body, Header, Panel } from '@cjdev-internal/visual-stack-x/Panel'
import { Grid } from '@cjdev-internal/visual-stack-x/Grid'
import HomeCard from '../../components/HomeCard'
import CommissionToolWikiLink from '../../components/Commission/CommissionToolWikiLink'
import { SnowOverlay, useSnow } from './SnowEffect'

const CommissionResult = () => {
  const { isUnauthorized } = useContext<CommissionAdminValues>(CommissionAdminContext)
  const { authorizations } = useContext<AuthValues>(AuthContext)
  const intl = useIntl()
  const user = useUser()
  const { snowActive, triggerSnow } = useSnow()

  return isUnauthorized ? <Unauthorized /> : (
    <PageContent>
      {snowActive && <SnowOverlay />}
      <div className="fintech-tool-page">
        <div className="fintech-tool-page-content">
          <Panel>
            <Header>
              <h2>
                <span onDoubleClick={triggerSnow} style={{ cursor: 'default', userSelect: 'none' }}>
                  {user.lastName} {user.firstName}
                </span>
                {` ${intl.formatMessage(messages.labelHomeWelcome)}`}
              </h2>
            </Header>
            <Body>
              <Grid columns="1fr 1fr" gap="large">
                {authorizations.includes('commission-admin') && (
                  <HomeCard
                    title={intl.formatMessage(messages.labelCommissionAdminTool)}
                    description={intl.formatMessage(messages.labelCommissionAdminToolDescription)}
                    mdiIconName={'file-arrow-left-right'}
                    Footer={CommissionToolWikiLink} />
                )}
                {authorizations.includes('alternate-payee') && (
                  <HomeCard
                    title={intl.formatMessage(messages.labelAlternatePayeeTool)}
                    description={intl.formatMessage(messages.labelAlternatePayeeToolDescription)}
                    mdiIconName={'bank-check'} />
                )}
                {authorizations.includes('payout-results') && (
                  <HomeCard
                    title={intl.formatMessage(messages.labelPayoutResultsTool)}
                    description={intl.formatMessage(messages.labelPayoutResultsToolDescription)}
                    mdiIconName={'cash-check'} />
                )}
              </Grid>
            </Body>
          </Panel>
        </div>
      </div>
    </PageContent>
  )
}

export default CommissionResult
